import { CreateOrderNewRequest, CreateOrderNewResponse, Discont, DiscontStatus, ID, OrderLogicShare } from '@project/shared-types';
import { sendMetrics } from '../../../shared/hooks/sendMetrics';
import { CreateOrderNewAPI } from './order.api';

interface CreateOrderData {
    service_hm_id: ID;
    email: string;
    description: string;
    count: number;
    url: string;
    discont: Discont | undefined;
    global_id: string;
}
interface CreateOrderHandlers {
    setErrorEmail: (error: string) => void;
    setErrorUrl: (error: string) => void;
    setIsLoadingOrder: (isLoading: boolean) => void;
    handleSuccses: (response: CreateOrderNewResponse) => void;
}

export class OrderServiceFront extends OrderLogicShare {
    static createOrder = async (data: CreateOrderData, handlers: CreateOrderHandlers) => {
        const { email, url, discont, count, description, service_hm_id, global_id } = data;
        const { setErrorEmail, setErrorUrl, setIsLoadingOrder, handleSuccses } = handlers;
        if (email.length == 0) {
            setErrorEmail("Укажите почту");
            sendMetrics("reachGoal", "clickPay_error_email");
            return;
        } else if (url.length == 0) {
            setErrorUrl("Укажите ссылку");
            sendMetrics("reachGoal", "clickPay_error_url");
            return;
        }
        sendMetrics("reachGoal", "clickPay");
        try {
            setIsLoadingOrder(true);
            let discontTrue = undefined;
            if (discont && discont.status === DiscontStatus.OK) {
                discontTrue = discont;
            }
            const dataOrder = {
                service_hm_id: service_hm_id,
                email: email,
                description: description,
                count: count,
                url: url,
                discont: discontTrue,
                jobs: [],
                global_id: global_id,
            } as CreateOrderNewRequest;
            const response = await CreateOrderNewAPI(dataOrder);
            if (response.errors && Object.values(response.errors).length > 0) {
                if (response.errors["email"]) setErrorEmail(response.errors["email"]);
                if (response.errors["url"]) setErrorUrl(response.errors["url"]);
            } else {
                if (response.url) {
                    handleSuccses(response);
                } else {
                    throw new Error("Не удалось создать заказ", { cause: response });
                }
            }
        } catch (error) {
            sendMetrics("reachGoal", "error_createOrder");
            console.error("Ошибка при получении карточек услуг:", error);
        }
    };
}